/**
 * Normalize activity_name to slug format for comparison and JSON storage.
 * Lowercase, non-alphanumeric chars (incl. Cyrillic) → underscore.
 * @param {string|object} name - "121 Varus", "121 Т3/Т4" or association object { name }
 * @returns {string} - "121_varus", "121_t3_t4"
 */
export function normalizeActivityName(name) {
	if (!name) return '';
	const str = typeof name === 'object' && name?.name ? name.name : String(name);
	return str
		.trim()
		.toLowerCase()
		.replace(/[^a-zа-яіїєґ0-9]+/gi, '_')
		.replace(/^_+|_+$/g, '');
}
